import { useContext, useCallback } from "react";
//
import { useSelector } from "src/redux/store";
import { AuthContext } from "../context/jwt/auth-context";

// import { AuthContext } from '../context/auth0/auth-context';
// import { AuthContext } from '../context/amplify/auth-context';
// import { AuthContext } from '../context/firebase/auth-context';

// ----------------------------------------------------------------------

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  const authenticated = useSelector(state => state.userProvider.authenticated);
  const user = useSelector(state => state.userProvider.user);

  if (!context) throw new Error("useAuthContext context must be use inside AuthProvider");

  const hasPermission = useCallback(
    permission => user?.permissions?.some(p => p.toLowerCase() === permission.toLowerCase()),
    [user]
  );

  const hasPermissions = useCallback(
    permissions =>
      permissions.some(r => user?.permissions.find(c => c.toLowerCase() === r.toLowerCase())),
    [user]
  );

  const hasEnterpriseRole = useCallback(
    role => user?.enterpriseRole?.some(r => r.toLowerCase() === role.toLowerCase()),
    [user]
  );

  const hasVoucherPermissions = useCallback(() => user?.voucherPermissions?.length > 0, [user]);

  const hasEnterpriseRoles = useCallback(
    roles => roles.some(r => user?.enterpriseRole.find(c => c.toLowerCase() === r.toLowerCase())),
    [user]
  );

  return {
    ...context,
    authenticated,
    user,
    hasPermission,
    hasPermissions,
    hasVoucherPermissions,
    hasEnterpriseRole,
    hasEnterpriseRoles,
  };
};
